var map = {
	"./a023-short1.jpg": 428,
	"./a023-short2.jpg": 429,
	"./a023-short3.jpg": 430,
	"./a023-short4.jpg": 431,
	"./a023-short5.jpg": 432,
	"./a023-short6.jpg": 433
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3367;